import "@measured/puck/puck.css";

import { Render, Data, migrate, DefaultComponents, DefaultRootFieldProps } from "@measured/puck";

import { Loading } from "src/components/utils/Loading";
import config from "./config";
import { MainContentLayout } from "../Layout/MainContentLayout";

type PuckRendererProps = {
    data: Data | Record<string, unknown> | undefined;
    isLoading?: boolean;
    isPreview?: boolean;
};

export const PuckRenderer = (props: PuckRendererProps) => {
    const { data, isLoading, isPreview = false } = props;

    if (isLoading) {
        return <Loading />;
    }

    if (!data) {
        return <></>;
    }

    const normalizedData = ensurePuckDataFormat(data);

    const content = (
        <div>
            <Render config={config} data={normalizedData} />
        </div>
    );

    return isPreview ? <MainContentLayout>{content}</MainContentLayout> : content;
};

const ensurePuckDataFormat = (data: unknown): Data => {
    try {
        if (!data || typeof data !== "object") {
            return {
                content: [],
                zones: {},
            } as unknown as Data;
        }

        const dataObj = data as Record<string, unknown>;

        if ("root" in dataObj) {
            const migratedData = migrate(dataObj as unknown as Data<DefaultComponents, DefaultRootFieldProps>, config);
            return migratedData as unknown as Data<DefaultComponents, DefaultRootFieldProps>;
        }

        return {
            content: Array.isArray(dataObj.content) ? dataObj.content : [],
            zones: dataObj.zones || {},
        } as unknown as Data;
    } catch (error) {
        return {
            content: [],
            zones: {},
        } as unknown as Data;
    }
};
